import { useCallback, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { Roles, roleTranslationKeys } from '~/data/user/role';

export const useRoleTranslations = () => {
  const { t } = useTranslation();

  const roleTranslations: { [p: string]: string } = useMemo(
    () =>
      Object.fromEntries(
        Object.entries(roleTranslationKeys).map(([key, value]) => [
          key,
          t(value),
        ]),
      ),
    [t],
  );

  const getRoleTranslation = useCallback(
    (role: Roles | string) =>
      !!roleTranslations[role] ? roleTranslations[role] : '',
    [roleTranslations],
  );

  return {
    roleTranslations,
    getRoleTranslation,
  };
};
